const SETUP_ORIGINS = ['new', 'migration', 'settings'];

export function questionnaireFromState(state) {
  return {
    locale: state.locale,
    household: structuredClone(state.household),
    dietaryPreference: state.dietaryPreference,
    avoidedAllergens: [...state.avoidedAllergens],
    dislikedFoods: [...state.dislikedFoods],
    mealPreferences: structuredClone(state.mealPreferences),
    stockedIngredientIds: [...(state.stockedIngredientIds || [])]
  };
}

export function isSetupSession(value) {
  return Boolean(value)
    && SETUP_ORIGINS.includes(value.origin)
    && Number.isInteger(value.step)
    && value.step >= 0
    && value.step <= 5
    && typeof value.previousPlannerSetup === 'string'
    && value.draft
    && typeof value.draft === 'object';
}

export function beginSetup(state, origin) {
  if (!SETUP_ORIGINS.includes(origin)) throw new Error('Unknown setup origin.');
  const next = structuredClone(state);
  next.setupSession = {
    origin,
    step: 0,
    previousPlannerSetup: next.migration.plannerSetup,
    draft: questionnaireFromState(next)
  };
  if (origin !== 'new') next.migration.plannerSetup = 'in-progress';
  return next;
}

export function updateSetupDraft(state, step, patch, nextStep = Math.min(5, step + 1)) {
  if (!isSetupSession(state.setupSession)) throw new Error('No active setup session.');
  const next = structuredClone(state);
  Object.assign(next.setupSession.draft, patch);
  next.setupSession.step = nextStep;
  return next;
}

export function cancelSetup(state) {
  if (!isSetupSession(state.setupSession) || state.setupSession.origin === 'new') return state;
  const next = structuredClone(state);
  const session = next.setupSession;
  next.migration.plannerSetup = session.origin === 'migration' ? 'dismissed' : session.previousPlannerSetup;
  next.setupSession = null;
  return next;
}

export function completeSetup(state, planner) {
  if (!isSetupSession(state.setupSession)) throw new Error('No active setup session.');
  const next = structuredClone(state);
  const { draft, origin } = next.setupSession;
  next.locale = draft.locale;
  next.household = structuredClone(draft.household);
  next.dietaryPreference = draft.dietaryPreference;
  next.avoidedAllergens = [...draft.avoidedAllergens];
  next.dislikedFoods = [...draft.dislikedFoods];
  next.mealPreferences = structuredClone(draft.mealPreferences);
  next.stockedIngredientIds = [...(draft.stockedIngredientIds || [])];
  next.planner = structuredClone(planner);
  next.onboardingComplete = true;
  if (origin !== 'new') next.migration.plannerSetup = 'completed';
  next.setupSession = null;
  return next;
}

export function recoverSetupState(state) {
  const next = structuredClone(state);
  if (next.onboardingComplete && next.migration?.plannerSetup === 'in-progress' && !isSetupSession(next.setupSession)) {
    next.migration.plannerSetup = next.migration.sourceVersion === null ? 'not-needed' : 'dismissed';
    next.setupSession = null;
  }
  return next;
}
